export default "__VITE_ASSET__2465e0ef__"